// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrap":"tooltipWrap__2HmFb","isVisible":"isVisible__351kc","onRight":"onRight__2x5kF","tooltip":"tooltip__3emr3"};